// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M4JN","col":"styles_col__2z7Cu","actions":"styles_actions__3kSXj","conflict":"styles_conflict__NiNJv"};